// @flow
import React, { PureComponent } from 'react';
import { withTheme } from 'styled-components';
import Button01 from 'components/Button/Button01';
import PresetSwitcher from './../PresetSwitcher';

import {
  SideBarWrap,
  ButtonWrap,
  TopBarWrap,
  TopBarTitle,
  Logo,
} from './SideBar.styled';
import ImageControls from './../ImageControls';

type Props = {
  canSave: boolean,
  onSave: () => void,
  onPresetChange: () => void,
  resetCropDisabled: boolean,
  onResetCrop: () => void,
};
class SideBar extends PureComponent<Props> {
  render() {
    const { canSave, onSave, onPresetChange } = this.props;
    return (
      <SideBarWrap>
        <TopBarWrap>
          <TopBarTitle>THE EDGE</TopBarTitle>
        </TopBarWrap>
        <PresetSwitcher onChange={onPresetChange} />
        <ImageControls {...this.props} />
        <ButtonWrap>
          <Button01 disabled={!canSave} title="SAVE" onClick={onSave} />
        </ButtonWrap>
      </SideBarWrap>
    );
  }
}

export default withTheme(SideBar);



// WEBPACK FOOTER //
// /opt/build/repo/src/modules/main/components/SideBar/SideBar.js